import * as Api from '@ViewModels';
import { stringify as stringifyQueryParams } from 'query-string';
import { ILocationState } from '../../../../../models';
import { CampaignType } from '../../../../../models/AdminModels';
import { useAdminUserSession } from '../../../../../models/hooks/adminStateHooks';
import { useFullscreenModal } from '../../../../../models/hooks/appStateHooks';
import {
	TemplateCategoriesViewModel,
	TemplateEditViewModel,
	TemplateWithStatusesViewModel,
} from '../../../../../viewmodels/AdminViewModels';
import { DropdownItem } from '../../../../../web/components-v2/Dropdown';

interface Props {
	campaignType: CampaignType;
	template: TemplateWithStatusesViewModel;
	categories: TemplateCategoriesViewModel;
	industry: Api.Industry;
}

export function TemplateCategoryViewDropdownItem({ campaignType, template, categories, industry }: Props) {
	const userSession = useAdminUserSession();
	const fullscreenModal = useFullscreenModal();
	const handleClick = async () => {
		const associatedTemplate = new TemplateEditViewModel(userSession);
		if (campaignType === CampaignType.Social && template.templateReference.template?.associatedTemplates?.length > 0) {
			await associatedTemplate?.load(
				template.templateReference.template?.associatedTemplates[0]?.id,
				CampaignType.Email
			);
		}
		const comboTemplate =
			campaignType === CampaignType.Social && template.templateReference.template?.associatedTemplates?.length > 0
				? new TemplateWithStatusesViewModel(userSession, associatedTemplate.getSystemTemplate(), industry)
				: template;
		if (campaignType === CampaignType.Social && template.templateReference.template?.associatedTemplates?.length > 0) {
			const socialCategories = new TemplateCategoriesViewModel(userSession, industry, CampaignType.Social);
			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: comboTemplate,
				viewModel: socialCategories,
			};
			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/email/edit',
				search: stringifyQueryParams({ fromSocial: true, readonly: true }),
				state: locationState,
			});
		} else if (campaignType === CampaignType.Email) {
			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: comboTemplate,
				viewModel: categories,
			};
			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/email/edit',
				search: stringifyQueryParams({ readonly: true }),
				state: locationState,
			});
		} else if (campaignType === CampaignType.Blog) {
			const blogTemplateCategoriesVm = new TemplateCategoriesViewModel(userSession, industry, CampaignType.Blog);

			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: template,
				viewModel: blogTemplateCategoriesVm,
			};
			const id = template.templateReference.template.id;
			fullscreenModal?.history?.push({
				pathname: `/campaign-templates/blog-post/edit/${id}`,
				search: stringifyQueryParams({ readonly: true }),
				state: locationState,
			});
		} else {
			const locationState: ILocationState<any, TemplateWithStatusesViewModel> = { model: template };
			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/social/edit',
				search: stringifyQueryParams({ readonly: true }),
				state: locationState,
			});
		}
	};
	return <DropdownItem onClick={handleClick}>View</DropdownItem>;
}
